import { Box, SvgIcon, Tab } from '@mui/material';
import { bool, node } from 'prop-types';
import React from 'react';

const tabSx = (theme, visible) => ({
  minWidth: 'calc(min(160px, 20%))',
  maxWidth: '20%',
  textTransform: 'none',
  fontSize: 15,
  minHeight: 63,
  color: '#738195',
  opacity: 1,
  ...(!visible && { display: 'none' }),
  '&.Mui-selected': {
    color: theme.palette.primary.ultraDark,
    '& .header-tab-icon': {
      color: theme.palette.primary.main,
    },
  },
  '& .header-tab-container': {
    display: 'flex',
    alignItems: 'center',
  },
  '& .header-tab-icon': {
    fontSize: 30,
    paddingRight: '10px',
  },
  '& .header-tab-text': {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    fontWeight: 600,
    letterSpacing: 'initial',
  },
});

const HeaderTab = ({ icon, children, visible = true, ...props }) => (
  <Tab
    {...props}
    disabled={!visible}
    component="div"
    sx={theme => tabSx(theme, visible)}
    label={
      <Box className="header-tab-container">
        <SvgIcon className="header-tab-icon">{icon}</SvgIcon>
        <Box component="span" className="header-tab-text">
          {children}
        </Box>
      </Box>
    }
  />
);
HeaderTab.propTypes = {
  icon: node.isRequired,
  visible: bool,
  children: node.isRequired,
};

export default HeaderTab;
